/**
 * Datum that manage in reactive var local state.
 */

import { makeVar, useReactiveVar } from '@apollo/client'

import { ArtistBottomTabFragment } from '../schema'

/**
 * Current Artist State from utoniq-core on current page.
 */
export const currentArtistVar = makeVar<ArtistBottomTabFragment | null>(null)

export const useCurrentArtistState = () => useReactiveVar(currentArtistVar)

export const linkingAnonymousAccount = makeVar<boolean>(false)

export const useLinkingAnonymousAccountState = () =>
  useReactiveVar(linkingAnonymousAccount)
